import { render, staticRenderFns } from "./sdproduct15.vue?vue&type=template&id=406f9399&scoped=true"
import script from "./sdproduct15.vue?vue&type=script&lang=js"
export * from "./sdproduct15.vue?vue&type=script&lang=js"
import style0 from "./sdproduct15.vue?vue&type=style&index=0&id=406f9399&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f9399",
  null
  
)

export default component.exports